// src/constants/testAccounts.ts
// 管理者・テスト用UID（クライアント側で使う版）。
// Source of truth: src/lib/agent/segments.ts の EXCLUDED_UIDS（配信対象から除外する4 UID）。
// segments.tsはfirebase-admin依存＋process.env.ADMIN_USER_IDを使うためサーバー専用。
// クライアントコンポーネント（"use client"）から参照したい場合はこちらの静的配列を使う。
// UIDを追加・変更した場合は両ファイルの整合を保つこと。
export const TEST_ADMIN_UIDS: string[] = [
  "user_3A3KY5w1fjtQBOA0asdp0YmQNXw",
  "user_3DHaaUtYCSenuXjpCtCYI1EKLnw",
  "user_3DshU7fAZJu2SRQ9N7WWWSiMQJR",
  "user_3B6ZXE2eo0hlfeBpb30HwwLLg4n",
];
